import Image from 'next/image'
import React from 'react'
import { urlFor } from 'src/common/lib/sanity/sanity'
// import Link from 'next/link'
import { BaseCard } from '../BaseCard'
import { BlogCardProps } from '../index'

// function truncateString(str: string, num: number) {
//     if (str.length <= num) {
//         return str
//     }
//     return str.slice(0, num) + '...'
// }

export interface LabelProps {
    labelColor: string
    labelType: 'date' | 'category'
}

export const BlogCard = ({
    href,
    imageURL,
    author,
    title,
    //previewText,
    // category,
    publishedDate,
    sanitySrc = null
}: BlogCardProps) => {
    return (
        <BaseCard href={href} cardType="blog" boxShadow>
            {sanitySrc !== null ? (
                <Image
                    width={225}
                    height={115}
                    src={sanitySrc.asset._ref}
                    loader={({ quality }) =>
                        urlFor(sanitySrc).size(225, 150).quality(quality).url()
                    }
                    placeholder="blur"
                    blurDataURL={urlFor(sanitySrc).blur(99) as any}
                />
            ) : (
                <img
                    alt={`${title} card image`}
                    src={imageURL}
                    width="225px"
                    height="115px"
                    className="object-cover max-h-[115px]"
                />
            )}
            <div>
                <div className="flex justify-between items-center mb-1 -mt-4 px-4">
                    <span className="bg-yf-green-400 text-white rounded px-4 py-0 font-medium text-sm mr-3">
                        {publishedDate}
                    </span>
                    {author.imageURL ? (
                        <img
                            width="32px"
                            height="32px"
                            className="rounded-full"
                            src={author.imageURL}
                        />
                    ) : (
                        <div style={{ width: '32px', height: '32px' }} />
                    )}
                </div>
                <div className="px-4 pb-2">
                    <p title={title} className="text-sm font-medium mb-1 line-clamp-3">
                        {title}
                    </p>
                    {/* <p className="text-xs font-light text-gray-600 line-clamp-3">
                        {previewText}
                    </p> */}
                </div>
            </div>
        </BaseCard>
    )
}
